import { SocialProofResources } from "@/src/cashback/LandingPage/Version/social-proof.Resources";
import { SocialProofResourcesEn } from "@/src/cashback/LandingPage/Version/social-proof.Resources.En";
import { languageSelector } from "@/src/contexts/UserAuthenticationContext";

import * as css from "./social-proof.module.css";

interface ISocialProofItem {
    proof: string;
    text: string;
}
function SocialProofItem({ proof, text }: ISocialProofItem) {
    return (
        <div className={css.socialProofComponent}>
            <p className={css.proof}> {proof}</p>
            <p className={css.proofText}> {text}</p>
        </div>
    );
}

export function SocialProof() {
    const socialProofResources = languageSelector(SocialProofResources, SocialProofResourcesEn);

    return (
        <div className={css.socialProofContainer}>
            {Object.values(socialProofResources).map(SocialProofItem)}
        </div>
    );
}
